import ReportViewer, {
  accountxReportUrl,
} from '@account-root/account-react/src/containers/DigitalReportModule/ReportViewer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'
import { useHistory, useLocation, useParams } from 'react-router'
import React from 'react'

export const CashBookStatusReport = () => {
  const history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const accountID = user.accountID
  let location = useLocation()
  const { CompanyID }: any = useParams()
  const editData = location?.state as any

  const parameters = [
    { name: 'accountid', value: accountID },
    { name: 'companyid', value: editData?.CompanyID },
    {
      name: 'startdocdate',
      value: editData?.StartDocDate
        ? formatDashDate(new Date(editData?.StartDocDate).toISOString())
        : null,
    },
    {
      name: 'enddocdate',
      value: editData?.EndDocDate
        ? formatDashDate(new Date(editData?.EndDocDate).toISOString())
        : null,
    },
    {
      name: 'trxndate',
      value: editData?.trxndate
        ? formatDashDate(new Date(editData?.TrxnDate).toISOString())
        : null,
    },
    { name: 'docno', value: editData?.DocNo },
    { name: 'doctype', value: editData?.DocType ?? undefined },
    { name: 'refno', value: editData?.RefNo ?? undefined },
    { name: 'paymentmethod', value: editData?.PaymentMethod },
    { name: 'paymenthoddesc', value: editData?.PaymentMethodDesc },
    { name: 'description', value: editData?.Description },
    { name: 'docamt', value: editData?.DocAmt },
    { name: 'docstatus', value: editData?.DocStatus },
  ]

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&'
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value
    })
    return reporturl
  }

  return (
    <>
      <MainHeader
        onClick={() => history.push(`/digital-reports/cash-book`)}
        mainBtn="close"
        smTitle="Cash Book"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Parameters' },
          { name: 'Cashbook Status Report', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('CashBookStatusReport', parameters),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  )
}
